import { render } from "./GestioneCredenziali.vue?vue&type=template&id=1d863be5&scoped=true"
import script from "./GestioneCredenziali.vue?vue&type=script&lang=js"
export * from "./GestioneCredenziali.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./GestioneCredenziali.vue?vue&type=style&index=1&id=1d863be5&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d863be5"]])

export default __exports__